import moment from 'moment-timezone';

// TODO: Move to config folder and set up for all regions
export const indexToDayMap = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};

export const initialWindows = [
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    [{ start: 0, end: 1439 }],
    // wrap
];

export const convertMinutesToTime = (minutes) => {
    if (minutes == null) return;
    return moment().startOf('day').minutes(minutes).format('hh:mm A');
};

export const formatWindows = (windows) => {
    if (!windows || !Object.keys(windows).length) return [];
    return Object.keys(windows).map((index) => {
        const title = indexToDayMap[index];
        const dayWindows = windows[index];
        return {
            title,
            rows: dayWindows
                .map((window) => {
                    if (window.start == null || window.end == null) return false;
                    return `${convertMinutesToTime(window.start)} - ${convertMinutesToTime(window.end)}`;
                })
                .filter(Boolean),
        };
    });
};

export const setDefaults = (processor) => {
    const defaultMilkTypes = ['conventional'];
    const defaultTrailerTypes = ['Tridem', 'Tri Axel', 'Quad', 'B-Train', 'Super', 'Regular'];

    return {
        ...processor,
        milk_types: processor?.milk_types?.length ? processor.milk_types : defaultMilkTypes,
        trailer_types: processor?.trailer_types?.length ? processor.trailer_types : defaultTrailerTypes,
    };
};
